export default __webpack_public_path__ + "static/media/bgMb.9a0e8190.png";